import React, { useState,useEffect, useContext } from 'react'
import '../../generalcss/main.css'
import './document.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight,faFileCirclePlus, faClose } from '@fortawesome/free-solid-svg-icons'
import { useNavigate, Link , useParams} from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'
import JisAlert from '../../components/jisalert'

function DocumentUpload() {
    const {casefeeid} = useParams();
    const { whichUpload } = useContext(ShareContext)

    const [uploadtype, setUploadType]=useState(whichUpload==null || whichUpload==''?'not-attest':whichUpload);
    const navigate = useNavigate()

    const [document, setDocuments] =useState({uplines:[], casedetail:{}});
    const url=`${Constants.apiUrl}/gazette/Document/${casefeeid}`;
    const tempUrl= `${Constants.apiUrl}/gazette/templates/document`;
    
    
    const [selectedItems, setSelectedItems] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [isLoading,setIsLoading]= useState(false);
    const [openTemp, setOpenTemp ] =useState(false);

    const [templates, setTemplates]=useState([]);
    const [activeRow, setActiveRow] = useState({});
    const [isPreview, setIsPreview] =useState(false);
    const [prevImgs, setPrevImgs] =useState([]);
    const [alert, setAlert]=useState ({open:false,title:'', subtitle:''})
    const [caseDetails, setCaseDetails] =useState({});

    useEffect(() => {
        LoadDocs();
        if(whichUpload=='template'){
            LoadTemplates();
        }
      }, [])
      useEffect(() => {
        if(uploadtype=='template'){
            LoadTemplates();
        }
      }, [uploadtype])

      const onOk=()=>{
        setAlert({...alert,open:false});
     }

    const handleUploadChange =async (e, rowIndex, fileIndex) => {
        var uline= {...document.uplines[rowIndex]};
        var updatedselectedItems={...selectedItems};
       // var updateditems=new Set(items);
        
        const files = e.target.files;
       
        console.log('file document');
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);

        var objUline={ DoclineId:uline.id,DocId: uline.docUploadId,doclineType:"component",gazfile:files[0], base64: b64.split(',')[1], filename:Constants.ReduceFilename(files[0]?.name), base64Ext:b64.split(',')[0] };
        console.log(objUline);
        updatedselectedItems[uline.id] = objUline;
        setSelectedItems(updatedselectedItems);
        console.log(updatedselectedItems);

        onPreview(uline.id,objUline);

        
      
    };



    const LoadDocs=()=>{
        setIsLoading(true);
        fetch(url, {
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
            },
          })
            .then((resp) => resp.json())
            .then((data) => {
                setIsLoading(false);
                console.log(data);
                if(data.code==0){
                    setDocuments(data);
                    setUploadType(data.doc1.doctumentType)
                    //setCaseDetails(data.casedetail);
                }
                
            })
            .catch(error => {
                console.error(error);
                setIsLoading(false);
            })
    }

    const LoadTemplates=()=>{
       // setIsLoading(true);
        fetch(tempUrl, {
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
            },
          })
            .then((resp) => resp.json())
            .then((data) => {
              //  setIsLoading(false);
                if(data.code==0){
                    setTemplates(data.templates);
                }
                
            })
            .catch(error => {
                console.error(error);
                //setIsLoading(false);
            })
    }
    // console.log(uploadedFiles);


    const onUploadFiles2= async()=>{
        const uploadurl=`${Constants.apiUrl}/gazette/uploadDocument/${casefeeid}/${uploadtype}`
        const formData = new FormData();
            var dataArray= Object.values(selectedItems);
            
            console.log(dataArray);
         
          console.log(dataArray)
          if(dataArray.length==0){
            return false;
          }

            // Sending the FormData using fetch
            setIsLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(dataArray),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false);
                if(data.code==0){
                    //saved already
                    setOpenDialog(true);
                  //  setAlert( {...alert, title:'Save Instrument', open:true, subtitle:`Please save the instrument before you see another document or you drag it off the screen before you continue.`, onOk })
           
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setIsLoading(false);
        });
    }

    const onPreview= async(id,uline)=>{
        const uploadurl=`${Constants.apiUrl}/gazette/uploadDocument/preview/${id}`
        
      
        var updatedselectedItems={...selectedItems};
       // var updateditems=new Set(items);
            // Sending the FormData using fetch
            setIsLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(uline),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false);
                console.log('preview details');
                console.log(data);
                if(data.code==0){
                    //saved already
                    var updated={...uline,prev:data}
                    updatedselectedItems[id] = updated;
                    setSelectedItems(updatedselectedItems);
                    
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setIsLoading(false);
        });
    }

  const onDeleteItem =(id) =>{
    var updatedselectedItems={...selectedItems};
    delete updatedselectedItems[id]
    setSelectedItems(updatedselectedItems);
  }

  const onOpenTemp=(item)=>{
    setOpenTemp(true);
    setActiveRow(item);
  }
  const onCloseTemp=()=>{
    setOpenTemp(false);
    
  }

  const onSelectTemplate=(selected)=>{
   // navigate('/upload/create-case')
   var updatedselectedItems={...selectedItems};
   // var updateditems=new Set(items);
   var uline=activeRow;
    
   
    var objUline={ DoclineId:uline.id,DocId: uline.docUploadId,templateid:selected.id, templatetitle:selected.title};
  
    updatedselectedItems[uline.id] = objUline;
    setSelectedItems(updatedselectedItems);
    console.log(updatedselectedItems);
    onCloseTemp();
  }

  return (
    <div className='upload-final'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>Document Upload for {document?.casedetail?.caseNumber}</h2>
                    </div>
                    <p>Your Role: Legal Counsel</p>
                </div>
                <p className="nav-status">Home/Specifications/Document-Upload</p>
            </div>
            <div className="tables">
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Document Title</th>
                                <th>Document selected</th>

                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        {uploadtype=='template'? <tbody>
                            {
                                document.uplines.map((item, id) => { return (
                                <tr key={id}>
                                    <td>DOC/JS/{casefeeid}/{item.docUploadId}/{item.id}</td>
                                    <td>{item.documentTitle}</td>
                                    <td>{item.selectedTemplate}</td>
                                    
                                    <td className={item.selectedTemplate!=null ? "status uploaded" :"status"}>{item.selectedTemplate!=null ? 'Template Selected' : 'Pending Template Selection'}</td>

                                   {(item.selectedTemplate!=null )  ?
                                   <td></td>
                                   : 
                                  <td className='file'>

                                    
                                    <div className="btn-upload" >
                                        <button className='black' onClick={()=>onOpenTemp(item)} title={selectedItems[item.id]?.templatetitle}> {selectedItems[item.id]==null?'Select Template': Constants.ReduceString(selectedItems[item.id]?.templatetitle, 30) } </button>
                                        {selectedItems[item.id]!=null && <button onClick={()=> onDeleteItem(item.id)} className="red">Delete</button>}
                                    </div>
                                   
 
                                    </td> 
                                    } 
                                </tr>
                                )})
                            }
                        </tbody>:<tbody>
                            {
                                document.uplines.map((item, id) => { return (
                                <tr key={id}>
                                    <td>DOC/JS/{casefeeid}/{item.docUploadId}/{item.id}</td>
                                    <td>{item.documentTitle}</td>
                                    <td>{item.caseNum}</td>
                                    
                                    <td className={item.filename!=null ? "status uploaded" :"status"}>{item.filename!=null ? 'Uploaded' : 'Pending Upload'}</td>

                                   {(item.filename!=null )  ?
                                   <td></td>
                                   : 
                                  <td className='file'>

                                            <div className="btn-upload" >
                                                <input type="file" accept="application/pdf" id={`file-upload-${id}-${0}`} 
                                                onChange={(e) => handleUploadChange(e, id, 0)}/>
                                                <label htmlFor={`file-upload-${id}-${0}`} title={selectedItems[item.id]?.gazfile?.name}>{selectedItems[item.id]==null?'Choose File': Constants.ReduceString(selectedItems[item.id]?.gazfile?.name, 30)  }</label>
                                                {selectedItems[item.id]!=null && <button onClick={()=> onDeleteItem(item.id)} className="red">Delete</button>}
                                            </div>
 
                                    </td> 
                                    } 
                                </tr>
                                )})
                            }
                        </tbody>}
                       
                        
                    </table>

                    <div style={{display:'flex', flexDirection:'row'}}>
                        
                        {uploadtype!='template' && Object.values(selectedItems).map((item, id) => { return (   
                        <div key={id} style={{width:240, alignItems:'center'}}>
                            <div onClick={()=> {
                                setIsPreview(true);
                                setPrevImgs(item.prev?.filenames)}}  className='prevBox'>
                            <img style={{width:200, height:400}} src={Constants.AbsoluteFiletoRelative(item.prev?.filenames[0])} />
                            <p>{item.gazfile?.name }</p>
                            </div>
                         
                        </div>

                     )})}
                    

                    </div>
                </div>

              {openDialog && 
              <div className={ "dialog-box open" }>
                    {uploadtype === 'attest' && 
                    <div className="wrapper">
                       
                        <h3>UPLOAD SUCCESSFUL</h3>
                        <div className="main">
                            <p>The upload was successful; the case will now move to the Process Section Assessor’s queue  </p>
                            <button className='red' onClick={ () =>window.location.replace(`${Constants.primarySite}/Users.aspx`)}>Ok
                            <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>
                    </div>}
                    {
                        uploadtype === 'not-attest' && 
                        <div className="wrapper">
                        <h3>UPLOAD IS SUCCESSFUL</h3>
                        <div className="main">
                            <p>Upload is successful! You opted for your document(s) to be commissioned through e-Swearing, kindly Click Ok and 
                                check back within your account to see if the Commissioner for Oath (CFO) has scheduled your document(s) for attestation/commissioning. 
                                Ensure you append your e-Signature, append e-Seal and append Date and timestamp electronically to the documents that doesn’t need commissioning before the CFO, 
                                if needed, if you haven’t done so manually before documents were uploaded,
                                 by clciking on e-Swearing tab and select each document that’s within the category.</p>
                            <div className="btns">
                                <button onClick={() =>  navigate('/upload/e-swearing')} className='red'>e-Swearing</button>
                                <button className='red' onClick={ () =>window.location.replace(`${Constants.primarySite}/Users.aspx`)}>Ok <FontAwesomeIcon icon={faArrowRight} /></button>
                            </div>  
                        </div>
                    </div>
                    }
                    {
                        uploadtype === 'template' && 
                        <div className="wrapper">
                        <h3>TEMPLATE SELECTED IS SUCCESSFUL </h3>
                        <div className="main">
                            <p>Click proceed to prepare the documents using the selected template(s).</p>
                            <div className="btns">
                            
                                <button onClick={() =>  navigate('/view-document-template',{state:{item:{...document.doc1, ...document.casedetail}}})} className='red'>Proceed</button>
                                <button onClick={ () =>window.location.replace(`${Constants.primarySite}/Users.aspx`)} className='red'>Back to Home Page</button>
                               {/*  <button className='red' onClick={ () =>window.location.replace(`${Constants.primarySite}/Users.aspx`)}>Ok <FontAwesomeIcon icon={faArrowRight} /></button> */}
                            </div>  
                        </div>
                    </div>
                    }
                    
                </div>
}  
          
            </div>
            {openTemp && 
          <div className='upload'><div className={ "dialog open" }>
            <div className="container">
                <div className="heading">
                    <h2>CASE DOCUMENT TEMPLATES</h2>
                    <FontAwesomeIcon icon={faClose} onClick={() => onCloseTemp()}/>
                </div>
                <div className="body">
                 { templates.map((item, id) => { return (   

                    <div className="template" key={id} onClick={() =>onSelectTemplate(item)} title={item.note}>
                        <h3>{item.title}</h3>
                        <div className="create">
                            <p>Select Template</p>
                            <FontAwesomeIcon icon={faFileCirclePlus} />
                        </div>
                        <div className="line"></div>
                    </div>
                   )})}   
                 
                </div>
            </div>
        </div></div>  
          }  
          {isPreview && 
          <div className='upload'><div className={ "dialog open" }>
            <div className="container">
                <div className="heading">
                    <h2>Preview File</h2>
                    <FontAwesomeIcon icon={faClose} onClick={() => setIsPreview(false)}/>
                </div>
                <div className="body">
                    <div style={{flexDirection:'row', width:'100%'}}> 
                      {prevImgs.map((prevImg, id) => { return (   
                            <img style={{width:'100%'}} src={Constants.AbsoluteFiletoRelative(prevImg)} />

                     )})}  
                    </div>
                </div>
            </div>
        </div></div>  
          }  
            <div className="down">
                <div className="goBack" onClick={() => navigate(`/upload/${casefeeid}`) }>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p>Back to Document Type</p>
                </div>
                <div className="btns">
                    <button onClick={() =>  onUploadFiles2()}>
                        Submit <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </div>
            </div>
        </div>
        <BackLoader open={isLoading}  />
        
    </div>
  )
}

export default DocumentUpload